<template>
    <MatchMedia v-slot="{ mobile, tablet }">
        <TgpLayout v-if="mobile" :layout="mobileLayout" :url-config="urlConfig" />
        <TgpLayout v-else-if="tablet" :layout="tabletLayout" :url-config="urlConfig" />
        <TgpLayout v-else :layout="desktopLayout" :url-config="urlConfig" />
    </MatchMedia>
</template>

<script>
import TgpLayout from "./TgpLayout";
import { MatchMedia } from "vue-component-media-queries";

export default {
    name: "TgpContent",
    components: {TgpLayout, MatchMedia},
    props: {
        layouts: {type: Object, required: true},
        joinUrl: {type: String, required: true},
        carryOverUrl: {type: String, required: true},
        defaultCarryOver: {type: String, default: ''},
        design: {type: String, required: true},
        tgpId: {type: Number, required: true},
    },

    computed: {
        mobileLayout() {
            return {name: 'mobile_square', zones: this.layouts['mobile_square'], gutters: false};
        },

        tabletLayout() {
            return {name: 'tablet_square', zones: this.layouts['tablet_square'], gutters: false};
        },

        desktopLayout() {
            return {name: 'desktop_square', zones: this.layouts['desktop_square'], gutters: false};
        },

        urlConfig() {
            return {
                joinUrl: this.joinUrl,
                carryOverUrl: this.carryOverUrl,
                defaultCarryOver: this.defaultCarryOver,
            };
        },
    },
}
</script>
